<template>
  <div>
    <div class="mainView" v-show="!PerformanceImprovementVueShow">
      <Card class="card card1">
        <div class="user">
          <div class="userHeader">
            <img v-if="basicInfo.portrait" :src="'data:image/jpeg;base64,' + basicInfo.portrait || ''" />
            <img v-else src="@/assets/headerImg.png" />
          </div>
          <div class="userName">
            <span>{{basicInfo.userName}}</span>
            <p>{{basicInfo.userEName}}</p>
          </div>
          <div class="userItem">
            <div class="item">
              <span class="tit"><!-- 员工号 -->{{$t('Employee_Code')}}</span><span class="content">{{basicInfo.empCode}}</span>
            </div>
            <Divider dashed />
            <div class="item">
              <span class="tit"><!-- 英文名字 -->{{$t('English_Name')}}</span><span class="content">{{basicInfo.userEName}}</span>
            </div>
            <Divider dashed />
            <div class="item">
              <span class="tit"><!-- 出生日期 -->{{$t('Date_of_Birth')}}</span><span class="content">{{date.dateVal(basicInfo.birthday,'YYYY-MM-DD')}}</span>
            </div>
            <Divider dashed />
            <div class="item">
              <span class="tit"><!-- 业务单元 -->{{$t('BU')}}</span><span class="content">{{basicInfo.businessUnit}}</span>
            </div>
            <Divider dashed />
            <div class="item">
              <span class="tit"><!-- 部门 -->{{$t('Department')}}</span><span class="content">{{basicInfo.department}}</span>
            </div>
            <Divider dashed />
            <div class="item">
              <span class="tit"><!-- 职能 -->{{$t('Funciton')}}</span><span class="content">{{basicInfo.postFun}}</span>
            </div>
            <Divider dashed />
            <div class="item">
              <span class="tit"><!-- 直接上级 -->{{$t('Line_Manager')}}</span><span class="content">{{basicInfo.dirSupName}}</span>
            </div>
            <Divider dashed />
            <div class="item">
              <span class="tit"><!-- 入职日期 -->{{$t('Effective_Join_Date')}}</span><span class="content">{{basicInfo.hireDate}}</span>
            </div>
            <Divider dashed />
            <div class="item">
              <span class="tit">{{$t('Company_Email')}}</span><span class="content">{{basicInfo.email}}</span>
            </div>
            <Divider dashed />
            <div class="item">
              <span class="tit">{{$t('system_account')}}</span><span class="content">{{basicInfo.gmdGaui}}</span>
            </div>
          </div>
          <!-- 上线先隐藏 -->
          <!-- <router-link to="/E97C32785C9AE39059617F3F1DC697B475A259E7C679B2FA/A3FFBEBFDB713E27"> -->
            <!-- <div class="seeMore"> 个人档案{{$t('Personal_Profile')}} ></div> -->
          <!-- </router-link> -->
        </div>
      </Card>
      <Card class="card card2">
        <div>
          <div class="progress progress1">
            <div class="progress1Item" :class="flagItem.startFlag == 1 ? 'progress1Item1' : ''" @click="targerClick('目标设定')">
              <img v-if="flagItem.startFlag == 1" src="@/assets/proIcon/pro1.png" alt=""/><img v-else src="@/assets/proIcon/pro1-4.png" alt="" /><span><!-- 目标设定 -->{{$t('Objective_Setting')}}</span>
            </div>
            <div class="progress1Item" :class="flagItem.midFlag == 1 ? 'progress1Item2' : ''" @click="targerClick('阶段回顾')">
              <img v-if="flagItem.midFlag == 1" src="@/assets/proIcon/pro2.png" alt=""/><img v-else src="@/assets/proIcon/pro2-2.png" alt="" /><span><!-- 阶段回顾 -->{{$t('Phase_Review')}}</span>
            </div>
            <div class="progress1Item" :class="flagItem.endFlag == 1 ? 'progress1Item3' : ''" @click="targerClick('年终总结')">
              <img v-if="flagItem.endFlag == 1" src="@/assets/proIcon/pro3.png" alt=""/><img v-else src="@/assets/proIcon/pro3-6.png" alt="" /><span><!-- 年终总结 -->{{$t('End-Year_Review_Over')}}</span>
            </div>
            <div class="progress1Item" :class="flagItem.finishFlag == 1 ? 'progress1Item4' : ''" style="cursor:default">
              <img v-if="flagItem.finishFlag == 1" src="@/assets/proIcon/pro4.png" alt=""/><img v-else src="@/assets/proIcon/pro4-1.png" alt="" /><span><!-- 完成 -->{{$t('Completed')}}</span>
            </div>
          </div>
          <div class="progress progress2">
            <div class="proLine" :style="{ width: proWidth + '%' }"></div>
          </div>
          <div class="progress progress3">
            <div class="progress3Item progress3Item1">
              <div class="itemSub" :class="minflagItem.startStatus == 1 ? 'itemSub1' : ''">
                <div class="icon">
                  <img v-if="minflagItem.startStatus == 1" src="@/assets/proIcon/pro1-1.png" alt=""/><img v-else src="@/assets/proIcon/pro1-5.png" alt="" />
                </div>
                <span><!-- 目标设定 -->{{$t('Objective_Setting')}}</span>
              </div>
              <div class="itemSub" :class="minflagItem.approvalFinish == 1 ? 'itemSub1' : ''" >
                <div class="icon">
                  <img v-if="minflagItem.approvalFinish == 1" src="@/assets/proIcon/pro1-2.png" alt="" /><img v-else src="@/assets/proIcon/pro1-6.png" alt="" />
                </div>
                <span><!-- 审批完成 -->{{$t('Approval_Completed')}}</span>
              </div>
              <div class="itemSub" :class="minflagItem.updateStatus == 1 && achUpdate!=8 ? 'itemSub1' : ''">
                <div class="icon">
                  <img v-if="minflagItem.updateStatus == 1 && achUpdate!=8" src="@/assets/proIcon/pro1-3.png" alt=""/><img v-else src="@/assets/proIcon/pro1-7.png" alt="" />
                </div>
                <span><!-- 目标修订 -->{{$t('Objective_Revision')}}</span>
              </div>
            </div>
            <div class="progress3Item progress3Item2">
              <div class="itemSub" :class="minflagItem.midStatus == 1 ? 'itemSub2' : ''">
                <div class="icon">
                  <img v-if="minflagItem.midStatus == 1" src="@/assets/proIcon/pro2-1.png" alt=""/><img v-else src="@/assets/proIcon/pro2-3.png" alt="" />
                </div>
                <span><!-- 填写回顾 -->{{$t('Fill_in_Self-Review')}}</span>
              </div>
            </div>
            <div class="progress3Item progress3Item3">
              <div class="itemSub" :class="minflagItem.endStatus == 1 ? 'itemSub3' : ''">
                <div class="icon">
                  <img v-if="minflagItem.endStatus == 1" src="@/assets/proIcon/pro3-1.png" alt=""/><img v-else src="@/assets/proIcon/pro3-7.png" alt="" />
                </div>
                <span><!-- 员工自评 -->{{$t('Employee_Self-Evaluation')}}</span>
              </div>
              <div class="itemSub" :class="minflagItem.managerAch == 1 ? 'itemSub3' : ''">
                <div class="icon">
                  <img v-if="minflagItem.managerAch == 1" src="@/assets/proIcon/pro3-2.png" alt=""/><img v-else src="@/assets/proIcon/pro3-8.png" alt="" />
                </div>
                <span><!-- 经理初评 -->{{$t('Manager_Draft_Evaluation')}}</span>
              </div>
              <div class="itemSub" :class="minflagItem.peopleStatus == 1 ? 'itemSub3' : ''">
                <div class="icon">
                  <img v-if="minflagItem.peopleStatus == 1" src="@/assets/proIcon/pro3-3.png" alt=""/><img v-else src="@/assets/proIcon/pro3-9.png" alt="" />
                </div>
                <span><!-- 人才评估会议 -->{{$t('People_Board_')}}</span>
              </div>
              <div class="itemSub" :class="minflagItem.managerInterview == 1 ? 'itemSub3' : ''">
                <div class="icon">
                  <img v-if="minflagItem.managerInterview == 1" src="@/assets/proIcon/pro3-4.png" alt="" /><img v-else src="@/assets/proIcon/pro3-10.png" alt="" />
                </div>
                <span><!-- 绩效面谈 -->{{$t('Performance_Feedback_')}}</span>
              </div>
              <div class="itemSub" :class="minflagItem.employeeFinish == 1 ? 'itemSub3' : ''">
                <div class="icon">
                  <img v-if="minflagItem.employeeFinish == 1" src="@/assets/proIcon/pro3-5.png" alt=""/><img v-else src="@/assets/proIcon/pro3-11.png" alt="" />
                </div>
                <span><!-- 员工确认 -->{{$t('Employee_Confirmation')}}</span>
              </div>
            </div>
            <div class="progress3Item  progress3Item4" ref="barLeftChartBox">
              <div id="barLeftChart" ref="barLeftChart"></div>
            </div>
          </div>
        </div>
      </Card>
      <Card class="card card3">
        <div class="card3Box">
          <div class="card3Date">
            <span><!-- 绩效年度 -->{{$t('Performance_Year')}}</span>
            <DatePicker :open="open" :value="year"  :options="options" confirm type="year" @on-change="handleChange" @on-clear="handleClear" @on-ok="handleOk">
              <a href="javascript:void(0)" @click="handleClick"  style="font-size:28px;color:#181A1F">
                <template v-if="year === ''">{{yearNow}}</template>
                <template v-else>{{ year }}</template>
                <Icon type="ios-calendar-outline" size="28" style="color:#28DCDB"></Icon>
              </a>
            </DatePicker>
          </div>
          <div class="userItem">
            <div class="item">
              <span class="tit"><!-- 业务单元 -->{{$t('BU')}}</span><span class="content">{{achInfo.businessUnit}}</span>
            </div>
            <Divider dashed />
            <div class="item">
              <span class="tit"><!-- 部门 -->{{$t('Department')}}</span><span class="content">{{achInfo.department}}</span>
            </div>
            <Divider dashed />
            <div class="item">
              <span class="tit"><!-- 职位 -->{{$t('Position')}}</span><span class="content">{{achInfo.position}}</span>
            </div>
            <Divider dashed />
            <div class="item">
              <span class="tit"><!-- 直线上级 -->{{$t('Line_Manager')}}</span><span class="content">{{achInfo.dirSupName}}</span>
            </div>
            <Divider dashed />
            <div class="item">
              <span class="tit"><!-- 状态 -->{{$t('Status')}}</span><span class="content">{{achInfo.status}}</span>
            </div>
            <Divider dashed />
            <div class="item">
              <span class="tit"><!-- 当前审批人 -->{{$t('Current_Approver')}}</span><span class="content">{{achInfo.approvalName}}</span>
            </div>
            <Divider dashed />
            <div class="item">
              <span class="tit"><!-- 修订状态 -->{{$t('Is_Update')}}</span><span class="content">{{achInfo.updateStatus}}</span>
            </div>
            <Divider dashed />
            <div class="item">
              <span class="tit"><!-- 修订审批人 -->{{$t('update_approver')}}</span><span class="content">{{achInfo.updateApprovalName}}</span>
            </div>
            <Divider dashed />
            <div class="item">
              <span class="tit"><!-- 年度 -->{{$t('Year')}}</span><span class="content">{{achInfo.year}}</span>
            </div>
          </div>
          <div class="seeMore1" @click="seemoreclick">  <!-- 查看更多 -->{{$t('Select_More')}}></div>
          <div class="seeMore" @click="toPageCK"> <!-- 绩效改进 -->{{$t('Apply_Performance_Improvement_Plan')}} ></div>
        </div>
      </Card>
    </div>
    <Spin size="large" fix v-if="spinShow"> </Spin>
    <PerformanceImprovementVue v-if="PerformanceImprovementVueShow" :userInfo="{ empCode: 'PL0004', year: '2022' }" @back="PerformanceImprovementVueShow = false"/>
    <Modal title="选择主管" width="1200" v-model="isShowPerformanceModal" :footer-hide="true">
      <Table
        :columns="performanceColumns"
        :data="achUpdateInfoList"
        border
      >
       <template
        slot-scope="{ row, index }"
        slot="action"
      >
       <Button
          type="primary"
          size="small"
          @click="toPage(row)"
        >
        选择
        </Button>
      </template>
      </Table>
    </Modal>
  </div>
</template>

<script>
import elementResizeDetectorMaker from "element-resize-detector";
import PerformanceImprovementVue from "./PerformanceImprovement.vue";
import axios from "axios";
import DateUtil from "@/util/DateUtil";
export default {
  components: { PerformanceImprovementVue },
  data() {
    return {
      date: new DateUtil(),
      options: {
          disabledDate (date) {
              return date && date.valueOf() > Date.now() - 86400000;
          }
      },
      open: false,
      PerformanceImprovementVueShow: false,
      year: "",
      progerssIndex: '',
      proWidth: "0",
      chartValue: 8,
      yearNow:'',
      basicInfo:{},
      achInfo:{},
      achUpdate:'',
      achStage:'',
      flagItem:{},
      minflagItem:{},
      spinShow:false,
      achUpdateLength:null,
      achUpdateInfoList: [],
      isShowPerformanceModal: false
    };
  },
  created(){
    this.yearNow=this.date.dateVal(new Date(),"YYYY")
    
  },
  computed: {
    performanceColumns() {
      return [
        {
          title: "操作",
          slot: "action",
          width: 90,
        },
        {
          title: "主管姓名",
          key: "dirSupUserName",
          align: "center",
          minWidth: 130,
        },
        {
          title: "开始时间",
          key: "startDate",
          align: "center",
          minWidth: 130,
        },
        {
          title: "结束时间",
          key: "endDate",
          align: "center",
          minWidth: 130,
        },
      ]
    }
  },
  mounted() {
   this.getData()
    
  },
  watch: {
      '$i18n.locale'(newValue) {
            this.barLeftChart();
      }
  },
  methods: {
    async getData(){
      this.spinShow=true
      this.selectAchRoute()
      this.selectBigAchRoute()
    },
    barLeftChart() {
      var value = this.achStage / 10;
      var data = [value, value, value];
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(
        document.getElementById("barLeftChart"),
        "westeros"
      );
      // 绘制图表
      myChart.setOption({
        backgroundColor: "#F5F4FF",
        cursor: "default",
        title: {
          text: this.achStage + " " + "/" + " " + this.achUpdate,
          textStyle: {
            fontSize: 20,
            fontFamily: "Microsoft Yahei",
            fontWeight: "normal",
            color: this.achStage > 2 ? "#fff":"#9A94FF",
            rich: {
              a: {
                fontSize: 28
              }
            }
          },
          x: "center",
          y: this.achStage < 6 ? "70%" : "40%"
        },
        graphic: [
          {
            cursor: "default",
            type: "group",
            left: "center",
            top: this.achStage < 6 ? "80%" : "50%",
            children: [
              {
                type: "text",
                z: 100,
                left: "10",
                top: "middle",
                textStyle: {
                  fontSize: 20,
                  fontFamily: "Microsoft Yahei",
                  fontWeight: "normal"
                },
                style: {
                  fill: this.achStage > 2 ? "#fff":"#9A94FF",
                  text: this.$t('Current_Progress'),
                  fontSize: 16
                }
              }
            ]
          }
        ],

        series: [
          {
             cursor: "default",
            type: "liquidFill",
            radius: 380,
            center: ["50%", "50%"],
            shape: "rect",
            amplitude: "2%",
            bottom: 0,
            data: data,
            backgroundStyle: {
              color: "#9a94ff1a"
            },
            itemStyle: {
              normal: {
                //饼状图阴影，值越大阴影亮度越高
                shadowBlur: 0,
                shadowColor: "#9A94FF"
              }
            },
            outline: {
              borderDistance: 0,
              itemStyle: {
                borderWidth: 0,
                borderColor: "#9A94FF",
                shadowBlur: 0
              }
            },
            color: ["rgba(144, 146, 255, 0.33)", "rgba(176, 152, 255, 0.33)"],
            label: {
              normal: {
                formatter: ""
              }
            },
           
          }
        ]
      });
      const _this = this;
      let erd = elementResizeDetectorMaker();
      erd.listenTo(this.$refs.barLeftChartBox, () => {
        _this.$nextTick(() => {
          myChart.resize();
        });
      });

      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    handleClick() {
      this.open = !this.open;
    },
    handleChange(date) {
      this.year = date;
    },
    handleClear() {
      this.open = false;
    },
    handleOk() {
      this.open = false;
      this.spinShow=true
      this.selectAchRoute()
      this.selectBigAchRoute()
    },
    selectAchRoute() {
        axios.post("/achLenderCockpit/selectAchRoute", {year:this.year}).then((res) => {
          this.spinShow=false
          if (res) {
              res.achInfo?this.achInfo=res.achInfo:this.achInfo={}
              this.minflagItem=res
              this.basicInfo=res.basicInfo
              this.achUpdateInfoList = res.achUpdateInfo || []
              this.achUpdateLength = Number(res.achUpdateLength)
              this.progerssIndex=Number(res.achStage)
              this.achStage=Number(res.achStage)
              this.achUpdate=Number(res.achUpdate)
              if(!this.year) {
                this.year=res.year
              }
              if(this.achUpdate==8 && this.progerssIndex >= 3){
                this.progerssIndex=this.progerssIndex+1
              }
              
              this.$nextTick(() => {
                this.barLeftChart();
              })
              
          }
      })
    },
    setProWidth() {
        if (this.flagItem.startFlag ==1 && this.flagItem.midFlag == 0 && this.flagItem.endFlag == 0 && this.flagItem.finishFlag == 0) {
          this.proWidth = "25";
        } else if (this.flagItem.midFlag == 1 &&this.flagItem.endFlag == 0 &&this.flagItem.finishFlag == 0) {
          this.proWidth = "50";
        } else if (this.flagItem.endFlag == 1 && this.flagItem.finishFlag == 0) {
          this.proWidth = "75";
          } else if(this.flagItem.finishFlag == 1){
          this.proWidth = "100";
        }else {
          this.proWidth='0'
        }
    },
    selectBigAchRoute() {
        axios.post("/achLenderCockpit/selectBigAchRoute", {year:this.year}).then((res) => {
        this.spinShow=false
          if (res) {
              this.flagItem=res
              this.setProWidth()  
          }
      })
    },
    toPageCK() {
        //achUpdateLength字段当字段=0时点击按钮提示:暂无绩效改进数据
        if(this.achUpdateLength  == 0) {
          this.$Message.info('暂无绩效改进数据');
          return
        }
        // 当 achUpdatelength= 1时 直接跳转绩效改进画面需要在achUpdatelnfo 中取第一个索引数据的值去进行跳转(之前是Object 现在改为List 了)
        if(this.achUpdateLength  == 1) {
          this.toPage(this.achUpdateInfoList[0])
          return
        }
        // 当achUpdatelength>1时弹框展示table
        if(this.achUpdateLength  > 1) {
          this.isShowPerformanceModal = true
        }

    },
    toPage(performanceItem){
      this.$router.push({
          path: '/F4861F9E4EB7B7DE62E634E5A81A4043/A3FFBEBFDB713E27',
          query: { isDirSup: performanceItem.isDirSup ,id:performanceItem.id,item:JSON.stringify(performanceItem),toPage:"staffview"}
      })
    },

    seemoreclick(){
      this.$emit('seemore',this.achInfo)
    },
    targerClick(name){
      if(name=='目标设定'&& this.flagItem.startFlag==0) return
      if(name=='阶段回顾'&& this.flagItem.midFlag==0) return
      if(name=='年终总结'&& this.flagItem.endFlag==0) return
      this.$emit('targerClick',name,this.year)
    }
  }
};
</script>

<style lang="scss" scoped>
.mainView {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.card {
  height: calc(100vh - 10px);
  overflow-y: auto;
}
.card1 {
  width: 26%;

  .user {
    padding: 0 20px;
    height: calc(100vh - 50px);
    position: relative;
    box-sizing: border-box;
    .userHeader {
      text-align: center;
      img {
        height: 118px;
      }
    }
    .userName {
      margin-top: 20px;
      span {
        font-size: 18px;
        font-weight: bold;
      }
      p {
        color: #8d94a1;
      }
    }
  }
}
.userItem {
  margin-top: 20px;
  .item {
    display: flex;
    padding: 3px 0;
    .tit {
      color: #636977;
      width: 30%;
      display: block;
    }
    .content {
      color: #181a1f;
      margin-left: 20px;
    }
  }
}
.card2 {
  width: 45%;
  .progress {
    padding: 20px;
    
  }
  .progress1 {
    display: flex;
    justify-content:space-around;
    .progress1Item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: auto;
      cursor: pointer;
      img {
        width: 48px;
      }
      span {
        font-weight: bolder;
        margin-top: 10px;
        font-size: 16px;
        color: #636977;
        
      }
    }
    .progress1Item1 {
      span {
        background-image: -webkit-linear-gradient(
          left,
          #26d999 0%,
          #28dcdb 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .progress1Item2 {
      span {
        background-image: -webkit-linear-gradient(
          left,
          #589aff 0%,
          #22bcff 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .progress1Item3 {
      span {
        background-image: -webkit-linear-gradient(
          left,
          #fdaa00 0%,
          #febb00 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .progress1Item4 {
      span {
        background-image: -webkit-linear-gradient(
          left,
          #9092ff 0%,
          #b098ff 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }
  .progress2 {
    width: 100%;
    height: 40px;
    background: #f7f9fc;
    border: 1px solid #f1f3f7;
    border-radius: 7px;
    margin-top: 16px;
    display: flex;
    align-items: center;
    .proLine {
      width: 100%;
      height: 26px;
      background-image: linear-gradient(
        276deg,
        #26d999 0%,
        #33adff 52%,
        #48c79c 100%
      );
      border-radius: 0 13px 13px 0;
    }
  }
  .progress3 {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    .progress3Item {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 25%;
      height: auto;

      .itemSub {
        display: flex;
        background: #f7f9fc;
        width: 90%;
        height: 68px;
        align-items: center;
        padding: 18px 10px;
        box-sizing: border-box;
        border-radius: 4px;
        border: 1px solid #f1f3f7;
        margin-top: 10px;
        .icon {
          width: 32px;
          height: 32px;
          border-radius: 32px;
          background: #dfe2e9;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 10px;
          img {
            width: 15px;
          }
        }
        span {
          color: #636977;
          white-space: nowrap;
          font-weight: bold;
          max-width: 100px;
          white-space: break-spaces;
        }
      }
      .itemSub1 {
        background: #f5fcfa;
        border: 1px solid #48c79c;
        .icon {
          background: #48c79c;
        }
        span {
          color: #181a1f;
        }
      }
      .itemSub2 {
        background: #f4fbff;
        border: 1px solid #33adff;
        .icon {
          background: #33adff;
        }
        span {
          color: #181a1f;
        }
      }
      .itemSub3 {
        background: #fffcf2;
        border: 1px solid #feb700;
        .icon {
          background: #feb700;
        }
        span {
          color: #181a1f;
        }
      }
    }
  }
  .progress3Item4 {
    width: 100%;
    margin-top: 10px;
    height: calc(100vh - 560px);
    border: 1px solid #9a94ff;
    border-radius: 4px;
    background: rgba(154, 148, 255, 0.1);
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    #barLeftChart {
      width: 100%;
      height: 100%;
      zoom:1.1 !important;
      
    }
    #barLeftChart>div>canvas:hover{
        cursor: default;
    }
    >>>div {
        cursor: default !important;
      }
  }
}

.card3 {
  width: 26%;
  padding: 20px;

  box-sizing: border-box;
  .card3Box {
    position: relative;
    width: 100%;
    height: calc(100vh - 120px);
  }
  .card3Date {
    display: flex;
    justify-content: center;
    align-items: center;
    span{
      margin-right: 20px;
      font-size: 22px;
    }
  }
}
.seeMore {
  position: absolute;
  bottom: 0px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  color: #0b6238;
  background: #f2f7f5;
  width: 100%;
  left: 0;
  cursor: pointer;
}
.seeMore1 {
  position: absolute;
  bottom: 60px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  color: #0b6238;
  background: #f2f7f5;
  width: 100%;
  left: 0;
  cursor: pointer;
}
@media screen and (max-width: 1220px) {
  .card1 {
    width: 100%;
    margin-bottom: 20px;
  }
  .card2 {
    width: 100%;
    margin-bottom: 20px;
  }
  .card3 {
    width: 100%;
    margin-bottom: 20px;
  }
}
>>>.ivu-divider-horizontal{
  margin: 8px 0;
}
</style>
<style lang="scss">
  
</style>


// WEBPACK FOOTER //
// src/components/index/components/StaffView.vue